import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M6.206 22L2 21.992V17.794L13.92 5.87402L18.126 10.08L6.206 22Z" fill="currentColor" />
    <path
      d="M18.9111 9.294L14.7051 5.088L17.7941 2C17.7941 2 18.9651 2.339 20.2851 3.659C21.6051 4.979 22.0001 6.206 22.0001 6.206L18.9111 9.294V9.294Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'PenFill');

export default Icon;
